interface FileUpload {
  files: string[];
}

const useUploadFileDto = async (files: FileList) => {
  const formData = new FormData();

  [...files].forEach((file) => {
    formData.append("files[]", file);
  });

  const response = await useFetchData<FetchData<FileUpload>>("/file/upload", {
    body: formData,
    method: "POST",
  });

  return {
    ...response,
  };
};

export { useUploadFileDto };
